module.exports = __webpack_public_path__ + "img/login-v2.5c6dffe0.svg";